import { createStyles, FormControlLabel, Grid, makeStyles, Paper, Switch, Theme, Typography } from '@material-ui/core';
import { Column, Columns, FormCheckbox, FormInput, FormSelect, Option, Subsection } from 'lqx-react';
import * as React from 'react';

const elevation = 1;

export const InputGroup = ({ id = undefined, children }) => {
    const classes = useStyles();
    return (
        <Paper
            id={id}
            elevation={elevation}
            className={classes.inputGroup}
        >
            {children}
        </Paper>
    )
}

export const CollapsableInputGroup = ({ id = undefined, headingText, actionClarificationText, $enable, children }) => {
    const classes = useStyles();
    return (
        <InputGroup id={id}>
            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="center"
                spacing={3}
            >
                <Grid container item xs={12}>
                    <Typography
                        variant="h5"
                        component="h5"
                        className={classes.panelHeading}
                    >
                        {headingText}
                    </Typography>
                    <Typography
                        component="span"
                        className={classes.actionClarification}
                    >
                        {actionClarificationText}
                    </Typography>
                    <FormControlLabel
                        className={classes.panelControls}
                        control={<Switch {...$enable.props} color="primary" />}
                        label={$enable.value ? "Yes" : "No"}
                        labelPlacement="end"
                    />
                </Grid>
                <Grid container item xs={12}>
                    {
                        $enable.value ?
                            children
                            :
                            null
                    }
                </Grid>
            </Grid>
        </InputGroup>
    )
}

export const EditContactAddress = ({ title, contact, relationship }) => {
    return (
        <Subsection
            title={title}
        >
            <Columns>
                <Column>
                    <FormInput
                        $value={relationship.$.billToCompanyName}
                        label="Name"
                    />
                    <FormInput
                        $value={contact.$.country}
                        label="Country"
                    />
                    <FormInput
                        $value={contact.$.lineTwo}
                        label="Address Line Two"
                    />
                    <FormInput
                        $value={contact.$.stateProvince}
                        label="State or Province"
                    />
                    <FormInput
                        $value={contact.$.name}
                        label="Contact Name"
                    />
                </Column>
                <Column>
                    <FormInput
                        $value={contact.$.city}
                        label="City"
                    />
                    <FormInput
                        $value={contact.$.lineOne}
                        label="Address Line One"
                    />
                    <FormInput
                        $value={contact.$.postalCode}
                        label="Zip Code"
                    />
                    <FormInput
                        $value={contact.$.email}
                        label="Contact Email"
                    />
                    <FormInput
                        $value={contact.$.phone}
                        label="Contact Phone"
                    />
                </Column>
            </Columns>
        </Subsection>
    )
}

export const OptionalInput = ({ checkboxLabel, $value, children }) => {
    const classes = useStyles();
    return (
        <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="center"
            spacing={3}
        >
            <Grid container item xs={12}>
                <FormControlLabel
                    control={
                        <FormCheckbox
                            {...$value.props}
                        />
                    }
                    label={checkboxLabel}
                />
            </Grid>
            <Grid container item xs={12}>
                {children}
            </Grid>
        </Grid>
    )
}

export const OptionalTextField = ({ checkboxLabel, textFieldLabel }) => {
    return (
        <OptionalInput
            checkboxLabel={checkboxLabel}
            $value={{}}
        >
            <FormControlLabel
                control={
                    <FormInput label=""
                    // $value={{}}
                    />
                }
                label={textFieldLabel}
                labelPlacement="end"
            />
        </OptionalInput>
    )
}

export const FormSelectWithDictionary = ({ $value, items, ...props }) => {
    return (
        <FormSelect label={props.label} disabled={props.controlDisabled} $value={$value}>
            {
                items.map((item) => {
                    return (
                        <Option key={item.id} value={item}>{item.id + ' - ' + item.description}</Option>
                    );
                })
            }
        </FormSelect>
    )
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        // heading: {
        //   fontSize: theme.typography.pxToRem(15),
        //   flexBasis: '33.33%',
        //   flexShrink: 0,
        // },

        panelHeading: {
            margin: 'auto auto auto 0',
            color: '#052C4C',
            fontSize: 18,
            fontWeight: 500,
            marginBottom: 10
        },

        actionClarification: {
            margin: 'auto 10px auto 0',
            color: '#767D84',
            fontSize: 12,
            fontWeight: 500
        },

        panelControls: {
            margin: 'auto 10px auto 0'
        },

        // secondaryHeading: {
        //   fontSize: theme.typography.pxToRem(15),
        //   color: theme.palette.text.secondary,
        // },

        inputGroup: {
            padding: theme.spacing(2),
            width: '98%',
            margin: 'auto',
            // textAlign: 'center',
            // color: theme.palette.text.secondary,
        },
    }),
);
